//
//
//
//
//

export default {
  props: {
    data: { type: Array, default() { return []; } },
    activeId: ''
  },
  methods: {
    handleClick(id) {
      this.$emit('item-click', id);
    }
  }
};



// WEBPACK FOOTER //
// ./packages/tree-selector/src/bread.vue